import Nullstack from 'nullstack';
export default function IconScissors({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-scissors",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "7",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "17",
    r: "3"
  }), "   ", Nullstack.element("line", {
    x1: "8.6",
    y1: "8.6",
    x2: "19",
    y2: "19"
  }), "   ", Nullstack.element("line", {
    x1: "8.6",
    y1: "15.4",
    x2: "19",
    y2: "5"
  }), " ");
}